import { render, staticRenderFns } from "./NoPortfolioYet.vue?vue&type=template&id=7fc94aa8&scoped=true&"
import script from "./NoPortfolioYet.vue?vue&type=script&lang=js&"
export * from "./NoPortfolioYet.vue?vue&type=script&lang=js&"
import style0 from "./NoPortfolioYet.vue?vue&type=style&index=0&id=7fc94aa8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc94aa8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VDivider,VImg,VRow})
